export const workspaces = [
  {
    id: 'home',
    label: 'Aujourd’hui',
    path: '/dashboard',
    tabs: [
      ['/dashboard', 'À traiter'],
      ['/analytics', 'Rapports'],
      ['/geographic', 'Villes'],
      ['/segments', 'Réactivation']
    ]
  },
  {
    id: 'moderation',
    label: 'Modération',
    path: '/reports',
    tabs: [
      ['/reports', 'Signalements'],
      ['/moderation/violations', 'Détections IA'],
      ['/verifications', 'Vérifications'],
      ['/verification-ai', 'IA de certification'],
      ['/moderation/stats', 'Qualité'],
      ['/verification-stats', 'Coûts de vérification']
    ]
  },
  {
    id: 'users',
    label: 'Utilisateurs',
    path: '/users',
    tabs: [['/users', 'Profils']]
  },
  {
    id: 'support',
    label: 'Support',
    path: '/tickets',
    tabs: [['/tickets', 'Demandes']]
  },
  {
    id: 'revenue',
    label: 'Revenus',
    path: '/subscriptions',
    tabs: [
      ['/subscriptions', 'Abonnements'],
      ['/premium-rewards', 'Accès offerts']
    ]
  },
  {
    id: 'acquisition',
    label: 'Acquisition',
    path: '/waitlist',
    tabs: [
      ['/waitlist', 'Liste d’attente'],
      ['/push-campaigns', 'Campagnes'],
      ['/notifications', 'Suivi des notifications'],
      ['/promotions', 'Promotions web']
    ]
  },
  {
    id: 'security',
    label: 'Traçabilité',
    path: '/audit-logs',
    tabs: [['/audit-logs', 'Journal des actions']]
  }
];
export function workspaceFor(pathname) {
  return (
    workspaces.find(space =>
      space.tabs.some(
        ([path]) => pathname === path || pathname.startsWith(path + '/')
      )
    ) || workspaces[0]
  );
}
